import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from 'vue';

import InterfaceLog from '@/components/InterfacesLogs/InterfaceLog.vue';
import { useInterfacesLogs } from '@/components/InterfacesLogs/InterfacesLogs.composables';


export default /*#__PURE__*/_defineComponent({
  __name: 'InterfacesLogs',
  props: {
	taskLogId: {
		type: String,
		required: true,
	},
},
  setup(__props) {

const props = __props


const { getPersonalInterfacesTaskLog, personalInterfaceTaskLogDetails } = useInterfacesLogs();
const isLoading = ref(true);

const showErrorMessage = ref(false);

const taskRunDetails = computed(() => personalInterfaceTaskLogDetails(props.taskLogId));

const initializeData = async () => {
	try {
		isLoading.value = true;
		showErrorMessage.value = false;
		await getPersonalInterfacesTaskLog(props.taskLogId);
	} catch (e) {
		console.error('initializeData personal logs error:', e);
		showErrorMessage.value = true;
	} finally {
		isLoading.value = false;
	}
};
initializeData();

return { __sfc: true,props, getPersonalInterfacesTaskLog, personalInterfaceTaskLogDetails, isLoading, showErrorMessage, taskRunDetails, initializeData, InterfaceLog }
}

})